import { Action } from '@ngrx/store';
import { IReportOutputFormatOption } from '@nha/api';
import { IReportDefinition } from '@nha/api/reporting/types/report-definition.type';
import { DocumentLoadingMessage, Message } from '@nha/types/document-loading-message.type';

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 */
export enum DocumentLoadingActionTypes {
	QueueMessages = '[DocumentLoading] QueueMessages',
	RequestSuccess = '[DocumentLoading] RequestSuccess',
	TypedRequestSuccess = '[DocumentLoading] TypedRequestSuccess',
	RequestByID = '[DocumentLoading] RequestByID',
	RequestError = '[DocumentLoading] RequestError',
	SetRetryAction = '[DocumentLoading] SetRetryAction'
}

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 */
export class QueueMessages implements Action {
	readonly type = DocumentLoadingActionTypes.QueueMessages;

	constructor(public payload: DocumentLoadingMessage) {}
}

export class RequestSuccess implements Action {
	readonly type = DocumentLoadingActionTypes.RequestSuccess;

	constructor(public payload: { id: string; stream: ArrayBuffer }) {}
}

export class TypedRequestSuccess implements Action {
	readonly type = DocumentLoadingActionTypes.TypedRequestSuccess;

	constructor(public payload: { id: string; stream: ArrayBuffer; data: IReportDefinition; reportOutputFormat: IReportOutputFormatOption }) {}
}

export class RequestByID implements Action {
	readonly type = DocumentLoadingActionTypes.RequestByID;

	constructor(public payload: { id: string; documentGuid: string }) {}
}

export class RequestError implements Action {
	readonly type = DocumentLoadingActionTypes.RequestError;

	constructor(public payload: { id: string; message: Message }) {}
}

export class SetRetryAction implements Action {
	readonly type = DocumentLoadingActionTypes.SetRetryAction;

	constructor(public payload: { id: string; action: Action }) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type DocumentLoadingActions = QueueMessages | RequestSuccess | RequestByID | RequestError | SetRetryAction;
